var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column vertical-list"},_vm._l((_vm.items),function(item,id){return _c('div',{key:id},[_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }